module.exports = __webpack_public_path__ + "fonts/SFUIText-Semibold.87436552.woff2";